import axios from "axios";
const DEFAULT_ERR_MESSAGE = "Unexpected Error Occurred. Please try again later."

export class TrainingAPI {
	url =
		import.meta.env.MODE === "production"
			? "https://api.gpsdataviz.com/api"
			: "http://127.0.0.1/api";



	getHelpVideoUrl = (key) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/help-center-video`, {
					params: { key },
				})
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	}

	getDropdowns = ({ metricTypes, keyType = 'name' }) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/dropdown`, {
					params: {
						metric_types: metricTypes,
						key_type: keyType
					}
				})
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	}

	getPlayerNotes = (playerId) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/playernotes`, {
					params: { player_id: playerId },
				})
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	performCustomAction = (payload = {}) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/admin/custom-action`, payload)
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	addPlayerNote = (playerId, team, note) => {
		const data = { player_id: playerId, team_id: team, notes: note };
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/playernotes`, data)
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	editPlayerNote = (notes, note_id) => {
		const data = { notes, note_id };
		return new Promise((resolve, reject) => {
			axios
				.patch(`${this.url}/playernotes`, data)
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	deletePlayerNote = (note_id) => {
		return new Promise((resolve, reject) => {
			axios
				.delete(`${this.url}/playernotes`, { data: { note_id } })
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	getOverviewChartV2 = (params) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/dvLiteOverview`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	updateSettingsAutomaticActions = (data) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/triggers`, data)
				.then((x) => resolve(x))
				.catch((e) => reject(e));
		});
	};

	getBullets = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/team-bullets`)
				.then((x) => resolve(x))
				.catch((e) => reject(e));
		});
	};

	updateBullets = (bullets) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/team-bullets`, { bullets })
				.then((x) => resolve(x))
				.catch((e) => reject(e));
		});
	};

	getSettingsAutomaticActions = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/triggers`)
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	updateOverviewDefaultMetrics = (metrics) => {
		const data = { metrics, metric_type: "overview" };
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/teamkeystats`, data)
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	getSingleStatTileData = (params) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/singleStatTileData`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	getSettingsDatapointAvg = (params) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/v2/playerdata/override`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	createSettingsDatapoint = (payload) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/v2/playerdata/override`, payload)
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	deleteSettingsDataPoint = (payload) => {
		return new Promise((resolve, reject) => {
			axios
				.delete(`${this.url}/v2/playerdata/override`, { data: payload })
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	getTeamList = async () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/v2/teams`)
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	sendWelcomeEmail = async (player_id) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/send-welcome-email`, { player_id })
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	sendWelcomeEmailCoach = async (coachEmail) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/send-welcome-email`, { email: coachEmail, user_type: "coach" })
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	deletePlayer = async (player_id) => {
		return new Promise((resolve, reject) => {
			axios
				.delete(`${this.url}/v2/player`, { data: { player_id } })
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	uploadPlayerCsv = async (file) => {
		return new Promise((resolve, reject) => {
			const formData = new FormData();
			formData.append("file", file);
			formData.append("bulk_add", true);
			axios
				.post(`${this.url}/v2/player`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then((x) => resolve(x))
				.catch((e) => reject(e));
		});
	};

	saveRestTravelDates = (data) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/restAndTravelDay`;
			axios
				.post(tempUrl, data)
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	getRestTravelDates = () => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/restAndTravelDay`;
			axios
				.get(tempUrl)
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	getCurrentUserData = () => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url.slice(
				0,
				this.url.length - 4
			)}/current_user/`;
			axios
				.get(tempUrl)
				.then((x) => resolve(x.data))
				.catch((e) => reject(e));
		});
	};

	savePlayerOrdering = (data) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/players_order`;
			let params = {
				player_mapping: data,
			};

			axios
				.post(tempUrl, params)
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getCostOfDay = (date_string) => {
		return new Promise((resolve, reject) => {
			const params = {
				date: date_string,
			};
			axios
				.get(
					`${this.url.slice(
						0,
						this.url.length - 4
					)}/get_prediction_day_intensity`,
					{ params }
				)
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getDrillCostPerMin = (player_id = undefined) => {
		return new Promise((resolve, reject) => {
			const params = { player: player_id };

			axios
				.get(`${this.url}/drillcostpermin`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	deleteInjury = (injury_id) => {
		return new Promise((resolve, reject) => {
			let params = {
				injury_id: injury_id,
			};

			axios
				.delete(`${this.url}/injury`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getRestDays = () => {
		return new Promise((resolve, reject) => {
			let params = {};

			axios
				.get(`${this.url}/restday`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	deleteRestDay = (rest_day_id) => {
		return new Promise((resolve, reject) => {
			let params = {
				rest_day_id: rest_day_id,
			};

			axios
				.delete(`${this.url}/restday`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	addRestDay = (date) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/restday`;
			let params = {
				date: date,
			};

			axios
				.post(tempUrl, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	storeS3 = (
		playertek_file,
		playertek_line,
		FB_file,
		FB_line,
		testing_file,
		testing_line
	) => {
		return new Promise((resolve, reject) => {
			var formData = new FormData();

			formData.append("playertek_line", JSON.stringify(playertek_line));
			formData.append("playertek", playertek_file);

			formData.append("testing_line", JSON.stringify(testing_line));
			formData.append("testing", testing_file);

			formData.append("FB_line", JSON.stringify(FB_line));
			formData.append("FB", FB_file);

			axios
				.post(`${this.url}/stores3`, formData, {
					"Content-Type": "multipart/form-data",
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	storeS3V2 = (
		file_type,
		file
	) => {
		return new Promise((resolve, reject) => {
			var formData = new FormData();
			formData.append("file", file);
			formData.append("file_type", file_type);

			axios
				.post(`${this.url}/v2/stores3`, formData, {
					"Content-Type": "multipart/form-data",
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getWeeklyRestDay = () => {
		return new Promise((resolve, reject) => {
			let params = {};

			axios
				.get(`${this.url}/wrestday`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	updateWeeklyRestDay = (date) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/wrestday`;
			let params = {
				date: date,
			};

			axios
				.post(tempUrl, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	wellnessEmail = (date, emails) => {
		return new Promise((resolve, reject) => {
			let params = {
				date: date,
				emails: emails,
			};

			axios
				.post(`${this.url}/email/wellness`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	sendWellnessNotification = (date) => {
		return new Promise(async (resolve, reject) => {
			let params = {
				date: date,
			};

			try {
				const response = await axios.get(
					`${this.url}/missingresponses`,
					{
						params,
					}
				);
				resolve(response.data);
			} catch (error) {
				reject(error);
			}
		});
	};

	sendRPENotification = (date) => {
		return new Promise(async (resolve, reject) => {
			let params = {
				date: date,
			};

			try {
				const response = await axios.get(`${this.url}/missingrpe`, {
					params,
				});
				resolve(response.data);
			} catch (error) {
				reject(error);
			}
		});
	};

	surveyreponsecount = (date) => {
		return new Promise((resolve, reject) => {
			let params = {
				date: date,
			};

			axios
				.get(`${this.url}/surveyresponsecount`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getTeamSurvey = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/survey`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	setWellness = (questions, deleteLast = false) => {
		if (!questions.length && !deleteLast) {
			return Promise.resolve({ message: "No questions provided." });
		}
		let question_list = questions.map((question, index) => {
			return { question_id: question.questionId, order: index + 1 };
		});
		let params = {
			bulk: true,
			question_list,
			delete_last: deleteLast
		};
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/survey`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getTeamInfo = () => {
		return new Promise((resolve, reject) => {
			let host = this.url;
			if (host.endsWith("/api")) {
				host = host.substring(0, host.lastIndexOf("/api"));
			}
			axios
				.get(`${host}/team-name/`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	emailDistanceReport = (
		start_date,
		end_date,
		emails,
		mode,
		position = undefined,
		player_group = undefined
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date,
				end_date,
				emails,
				mode,
				position,
				player_group

			};
			const start = Date.now();
			axios
				.post(`${this.url}/distance_breakdown_report`, params, {
					timeout: 180000,
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					const end = Date.now();
					console.log("Time elapsed", end - start);

					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "The report will be sent shortly."
						reject(custom_err);
					}

					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	emailACWRAnalysisReport = (
		date,
		emails,
		position = undefined,
		player_group = undefined,
		session = undefined
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				date,
				emails,
				position,
				player_group,
				session
			};
			const start = Date.now();
			axios
				.post(`${this.url}/acwr_analysis_report`, params, {
					timeout: 180000,
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					const end = Date.now();
					console.log("Time elapsed", end - start);

					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "The report will be sent shortly."
						reject(custom_err);
					}

					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	emailPrePostBodyWeightReport = (
		date,
		position=undefined,
		player_group=undefined
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				date,
				position,
				player_group
			};
			const start = Date.now();
			axios
				.post(
					`${this.url}/pre-post-bw-report`, 
					{...params},
					{ 
						responseType: "blob",
						validateStatus: function (status) {
							return status >= 200 && status < 300;
						},
					}
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					const end = Date.now();
					console.log("Time elapsed", end - start);

					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "The report will be sent shortly."
						reject(custom_err);
					}
					
					if (e?.response?.status === 422) {
						reject("No Data Found")
					}
					
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	emailForcePlateReport = ({
		date,
		agg,
		comparison,
		metrics,
		emails,
		position = undefined,
		player_group = undefined,
		group_by_position = false,
		sessions
	}) => {
		return new Promise((resolve, reject) => {
			let params = {
				date,
				agg,
				comparison,
				metrics,
				emails,
				position,
				player_group,
				group_by_position,
				sessions
			};
			const start = Date.now();
			axios
				.post(`${this.url}/forceplatereport`, params, {
					timeout: 180000,
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					const end = Date.now();
					console.log("Time elapsed", end - start);

					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "The report will be sent shortly."
						reject(custom_err);
					}

					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	emailTestingReport = ({
		date,
		agg,
		comparison,
		metrics,
		emails,
		position = undefined,
		player_group = undefined,
		group_by_position = undefined,
		sessions
	}) => {
		return new Promise((resolve, reject) => {
			let params = {
				date,
				agg,
				comparison,
				metrics,
				emails,
				position,
				player_group,
				group_by_position,
				sessions
			};
			const start = Date.now();
			axios
				.post(`${this.url}/testingreport`, params, {
					timeout: 180000,
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					const end = Date.now();
					console.log("Time elapsed", end - start);

					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "The report will be sent shortly."
						reject(custom_err);
					}

					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	emailGPSReport = (date, emails, session, player_group, position, coaches_report) => {
		return new Promise((resolve, reject) => {
			let params = {
				date,
				emails,
				session,
				player_group,
				position,
				coaches_report
			};
			const start = Date.now();
			axios
				.post(`${this.url}/gpsreport`, params, {
					params,
					timeout: 180000,
				})
				.then((x) => {
					resolve(x.data)
				})
				.catch((e) => {
					if (e?.response?.status === 422) {
						resolve(e?.response?.data || "No data found");
					}
					const end = Date.now();
					console.log("Time elapsed", end - start);
					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "The report will be sent shortly."
						reject(custom_err);
					}

					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	emailIndividualPlayerReport = (player_id, start_date, end_date, emails, report_types, metrics) => {
		return new Promise((resolve, reject) => {
			let params = {
				player_id,
				start_date,
				end_date,
				emails,
				report_types,
				metrics
			};
			const start = Date.now();
			axios
				.post(`${this.url}/player-report`, params, {
					params,
					timeout: 180000,
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					const end = Date.now();
					console.log("Time elapsed", end - start);
					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "The report will be sent shortly."
						reject(custom_err);
					}

					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	emailBulkReportCards = (start_date, end_date, emails) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date,
				end_date,
				emails,
			};
			const start = Date.now();
			axios
				.post(`${this.url}/bulk-report-cards`, params, {
					params,
					timeout: 180000,
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					const end = Date.now();
					console.log("Time elapsed", end - start);
					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "The report will be sent shortly."
						reject(custom_err);
					}

					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	addPracticePlan = (data, date) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/practiceplan`;
			let params = {
				data: data,
				date: date,
			};

			axios
				.post(tempUrl, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getPracticePlan = (start_date, end_date, player_id = undefined) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date,
				end_date,
			};
			if (player_id) params["player"] = player_id;

			axios
				.get(`${this.url}/practiceplan`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	addGame = (opponent, date, home, bulk = false, file = null) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/game`;
			
			// If csv file is provided, use FormData to upload
			if (bulk) {
				const formData = new FormData();
				formData.append("file", file);
				formData.append("bulk", bulk);

				axios
					.post(tempUrl, formData, {
						headers: {
							"Content-Type": "multipart/form-data",
						},
					})
					.then((x) => resolve(x.data))
					.catch((e) => {
						reject();
					});
				return;
			}

			// Adding a single game
			let params = {
				opponent: opponent,
				date: date,
				home: home,
				bulk: bulk,
				team_score: null,
				opponent_score: null,
			};

			axios
				.post(tempUrl, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	deleteGame = (game_id) => {
		return new Promise((resolve, reject) => {
			let params = {
				game_id: game_id,
			};

			axios
				.delete(`${this.url}/game`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	addDrill = (name) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/drills`;
			const teamId = localStorage.getItem("team-id");
			let params = {
				name: name,
				"team-id": teamId,
			};

			axios
				.post(tempUrl, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getDrillData = (startDate, endDate, drills) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: startDate,
				end_date: endDate,
				drills: drills.toString(),
			};

			axios
				.get(`${this.url}/drilldata`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getDrills = (start_date = null, end_date = null, all = true) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
				all: all,
			};

			axios
				.get(`${this.url}/drills`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getDataTypesForReport = (date) => {
		return new Promise((resolve, reject) => {
			let params = {
				date,
			};

			axios
				.get(`${this.url}/dailyreport/datatypes`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	mergeDrills = (to_remove, to_assign) => {
		return new Promise((resolve, reject) => {
			let params = {
				to_remove: to_remove,
				assign_to: to_assign,
			};
			axios
				.post(`${this.url}/mergedrills`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	getAllQuestions = () => {
		return new Promise((resolve, reject) => {
			let params = {
				with_answers: true,
			};
			axios
				.get(`${this.url}/questions`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getAllGames = () => {
		return new Promise((resolve, reject) => {
			let params = {
				all: true,
			};

			axios
				.get(`${this.url}/game`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getBreakdownTrainings = (
		date,
		selected_position,
		selected_player_groups,
		session_filter,
		drills
	) => {

		return new Promise((resolve, reject) => {
			let params = {
				date: date,
				position: selected_position,
				player_groups: selected_player_groups,
				session: session_filter,
				drills,
			};

			axios
				.get(`${this.url}/breakdown`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getTeamACWR = (params) => {
		return new Promise((resolve, reject) => {
			const teamId = localStorage.getItem("team-id");
			axios
				.get(`${this.url}/teamacwr`, {
					params: { ...params, "team-id": teamId },
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.log(e);
					reject();
				});
		});
	};

	emailBreakdownChart = (
		date,
		selected_positions,
		selected_player_groups,
		selected_session,
		selected_drills,
		selected_emails
	) => {

		return new Promise((resolve, reject) => {
			let params = {
				date: date,
				positions: selected_positions,
				player_groups: selected_player_groups,
				session: selected_session,
				drills: selected_drills,
				emails: selected_emails
			};

			axios
				.post(`${this.url}/email/breakdown`, params)
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	exportPDFBreakdownChart = (
		date,
		selected_positions,
		selected_player_groups,
		selected_session,
		selected_drills
	) => {

		return new Promise((resolve, reject) => {
			let params = {
				date: date,
				positions: selected_positions,
				player_groups: selected_player_groups,
				session: selected_session,
				drills: selected_drills
			};

			axios
				.post(`${this.url}/export-pdf/breakdown`, params, { responseType: "blob" })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	getPlayerCharts = (
		player_id,
		start_date,
		end_date,
		weekly,
		session,
		show_predictions
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
				player_id,
				weekly: weekly,
				session: session,
				show_predictions: show_predictions,
			};

			axios
				.get(`${this.url}/playerchart`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					//console.error(e);
					reject(e);
				});
		});
	};

	emailPlayerCharts = (name, start_date, end_date, weekly) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
				name: name,
				weekly: weekly,
			};

			axios
				.get(`${this.url}/email/playerchart`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getTrainings = ({
		start_date,
		end_date,
		weekly,
		pos_filter,
		player_group = undefined,
		session_filter = undefined,
		show_predictions = false,
	}) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
				weekly: weekly,
				position: pos_filter,
				player_group: player_group,
				session: session_filter,
				show_predictions: show_predictions,
			};

			axios
				.get(`${this.url}/trainings`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	emailOverviewCharts = (start_date, end_date, weekly) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
				weekly: weekly,
			};

			axios
				.get(`${this.url}/email/overview`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getBaselineOverview = () => {
		return new Promise((resolve, reject) => {
			let params = {};

			axios
				.get(`${this.url}/baselineoverview`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getTestingData = ({
		start_date,
		end_date,
		metric_type,
		is_movement_sig,
		pos_filter,
		stats,
		metric_id,
		player_id,
		player_group,
		sessions,
		metrics = [],
		multi_metrics = ""
	}) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
				metric_type,
				is_movement_sig,
				player_id,
				position: pos_filter,
				stats,
				metric_id,
				player_group,
				sessions,
				metrics,
				multi_metrics
			};

			axios
				.get(`${this.url}/testingdata`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getDefaultTestingStats = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/testingkeystats`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getDefaultStats = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/teamkeystats`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	validateTeam = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/team-validation`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	updateDefaultTestingStats = (metrics) => {
		return new Promise((resolve, reject) => {
			let params = {
				metrics: metrics,
			};
			axios
				.post(`${this.url}/testingkeystats`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	updateDefaultForcePlateStats = (metrics) => {
		return new Promise((resolve, reject) => {
			let params = {
				metrics: metrics,
				metric_type: "forceplate",
			};
			axios
				.post(`${this.url}/teamkeystats`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	updateDefaultStats = (metrics, metricType) => {
		return new Promise((resolve, reject) => {
			let params = {
				metrics: metrics,
				metric_type: metricType,
			};
			axios
				.post(`${this.url}/teamkeystats`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getRadarData = ({ start_date, end_date, metrics, name, pos_filter, player_group, sessions }) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
				metrics: metrics,
				name: name,
				position: pos_filter,
				player_group,
				sessions
			};

			axios
				.get(`${this.url}/testingradar`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	addTrainingV2 = (
		params,
		uuid
	) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/upload-data`;
			const start = Date.now();
			axios
				.post(tempUrl, { ...params }, { headers: { 'gpsdv-uuid': uuid } })
				.then((x) => resolve(x.data))
				.catch((e) => {
					const end = Date.now();
					console.log("Time elapsed", end - start);

					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "Trainings added. If you requested a report, it will be sent shortly."
						reject(custom_err);
					}
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	addTraining = (
		FB,
		testing,
		playerTrek,
		drills,
		lift_type,
		send_email,
		start_date,
		end_date,
		fp_start_date,
		fp_end_date,
		custom_date,
		testing_start_date,
		testing_end_date,
		testing_data_provider,
		data_upload_action,
		emails,
		outliers
	) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/trainings`;
			let params = {
				FB: FB,
				testing: testing,
				playerTrek: playerTrek,
				drills: drills,
				lift_type: lift_type,
				send_email: send_email,
				start_date: start_date,
				end_date: end_date,
				fp_start_date: fp_start_date,
				fp_end_date: fp_end_date,
				custom_date: custom_date,
				testing_start_date: testing_start_date,
				testing_end_date: testing_end_date,
				testing_data_provider: testing_data_provider,
				data_action: data_upload_action,
				emails: emails,
				outliers: outliers
			};
			const start = Date.now();
			axios
				.post(tempUrl, { ...params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					const end = Date.now();
					console.log("Time elapsed", end - start);

					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "Trainings added. If you requested a report, it will be sent shortly."
						reject(custom_err);
					}
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	getYearTrainingsV2 = (start_date, end_date) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
			};
			axios
				.get(`${this.url}/v2/year`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.log(e);
					// console.error(e);
					reject();
				});
		});
	};

	getFpAndTestingBreakdownTable = (
		start_date,
		end_date,
		metricId,
		stat,
		position_filter = []
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date,
				end_date,
				metricId,
				position_filter,
				stat,
			};
			axios
				.get(`${this.url}/fpandtesting/breakdowntable`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	sendDailyReportFootball = ({ data_types_object, date, emails }) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/dailyreport/football`;
			let params = {
				...data_types_object,
				date,
				emails,
			};
			axios
				.post(tempUrl, { ...params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	sendDailyReportOlympic = ({ data_types_object, date, emails }) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/dailyreport/olympic`;
			let params = {
				...data_types_object,
				date,
				emails,
			};
			axios
				.post(tempUrl, { ...params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	getDrillBreakdownIndividual = (drill, date, position) => {
		return new Promise((resolve, reject) => {
			let params = {
				drill: drill,
				date: date,
				position: position,
			};

			axios
				.get(`${this.url}/drillbreakdown`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getDrillCompare = () => {
		return new Promise((resolve, reject) => {
			let params = {};

			axios
				.get(`${this.url}/drillcompare`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getDrillBreakdownTeam = (data) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/drillbreakdown`;
			let body = {
				pairs: data,
			};

			axios
				.post(tempUrl, body, {
					headers: {
						"Content-Type": "application/json",
					},
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					alert(e?.response?.data);
					reject();
				});
		});
	};

	getDrillDates = (drill) => {
		return new Promise((resolve, reject) => {
			let params = {
				drill: drill,
			};

			axios
				.get(`${this.url}/drilldates`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getBaseline = (position) => {
		return new Promise((resolve, reject) => {
			let params = {
				position: position,
			};

			axios
				.get(`${this.url}/baseline`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	getInjuries = (filters = {}) => {
		return new Promise((resolve, reject) => {
			// Build URLSearchParams to properly handle array parameters for Django's getlist()
			const params = new URLSearchParams();

			// Add main filter parameters if provided
			if (filters.start_date) params.append('start_date', filters.start_date);
			if (filters.end_date) params.append('end_date', filters.end_date);
			if (filters.player) params.append('player', filters.player);
			
			// Handle array parameters properly for Django's getlist()
			if (filters.positions && filters.positions.length > 0) {
				filters.positions.forEach(position => {
					params.append('positions', position);
				});
			}
			if (filters.groups && filters.groups.length > 0) {
				filters.groups.forEach(group => {
					params.append('groups', group);
				});
			}

			// Support legacy injury-specific filters for table column filtering
			if (filters.injury_types && filters.injury_types.length > 0) {
				filters.injury_types.forEach(type => {
					params.append('injury_types', type);
				});
			}
			if (filters.injury_locations && filters.injury_locations.length > 0) {
				filters.injury_locations.forEach(location => {
					params.append('injury_locations', location);
				});
			}
			if (filters.injury_status && filters.injury_status.length > 0) {
				filters.injury_status.forEach(status => {
					params.append('injury_status', status);
				});
			}

			axios
				.get(`${this.url}/injury?${params.toString()}`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	updateInjury = (data) => {
		return new Promise((resolve, reject) => {
			let params = {
				data: data,
			};
			axios
				.post(`${this.url}/injury`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	newInjury = (player, injury_location, injury_type, date) => {
		return new Promise((resolve, reject) => {
			let params = {
				player: player,
				injury_location: injury_location,
				injury_type: injury_type,
				injury_start_date: date,
			};
			axios
				.post(`${this.url}/newinjury`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	newInjuryV2 = (payload) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/newinjury`, payload)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e);
				});
		});
	};

	updateBaseline = (state) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/baseline`, state)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	updatePlayer = (
		player_id,
		player_number,
		player_position,
		player_top_speed,
		player_trimp_min,
		player_trimp,
		player_max_hr,
		player_bw,
	) => {
		return new Promise((resolve, reject) => {
			let data = {
				player_id,
				number: player_number,
				position: player_position,
				top_speed: player_top_speed,
				trimp_min: player_trimp_min,
				trimp: player_trimp,
				max_hr: player_max_hr,
				bodyweight_baseline: player_bw
			};

			axios
				.patch(`${this.url}/v2/player`, data)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e);
				});
		});
	};

	editPlayer = (params) => {
		return new Promise((resolve, reject) => {
			if (params.first_name && params.last_name)
				params.name = params.first_name + " " + params.last_name;
			axios
				.patch(`${this.url}/v2/player`, params)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);

					reject(e);
				});
		});
	};

	getPlayer = (first_name, last_name, player_id) => {
		return new Promise((resolve, reject) => {
			let params = {
				first_name: first_name,
				last_name: last_name,
				player_id,
			};

			axios
				.get(`${this.url}/v2/player`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e);
				});
		});
	};

	getPlayerGroups = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/player_groups`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	createPlayerGroup = (name) => {
		return new Promise((resolve, reject) => {
			let params = {
				name,
			};

			axios
				.post(`${this.url}/player_groups`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);

					reject();
				});
		});
	};

	editPlayerGroup = (
		name,
		new_name = undefined,
		included_in_report = undefined
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				name,
				new_name,
				included_in_report,
			};

			axios
				.post(`${this.url}/player_groups`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);

					reject();
				});
		});
	};

	deletePlayerGroup = (name) => {
		return new Promise((resolve, reject) => {
			let params = {
				name,
			};

			//delete not working. hacky workaround using put
			axios
				.put(`${this.url}/player_groups`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					console.log(e, { params });

					reject();
				});
		});
	};

	updatePlayerGroupMapping = (player_id, name, action) => {
		return new Promise((resolve, reject) => {
			let params = {
				player_id,
				name,
				action,
			};

			axios
				.post(`${this.url}/update_player_groups_mapping`, params, {
					params,
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getTeamMetrics = (
		include_wellness = false,
		include_testing = false,
		include_forceplate = false,
		include_nutrition = false,
		individual = "true"
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				individual: individual,
				wellness: include_wellness.toString(),
				testing: include_testing.toString(),
				forceplate: include_forceplate.toString(),
				nutrition: include_nutrition.toString(),
			};

			axios
				.get(`${this.url}/assignmetrics`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getMetricOrder = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/metrics_order`, {})
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	saveMetricOrdering = (data) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/metrics_update`;
			let params = {
				metric_mapping: data,
			};

			axios
				.post(tempUrl, params)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getBaselineChart = (
		date,
		sort_by,
		selected_position,
		selected_player_group
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				date: date,
				sort_by: sort_by,
				position: selected_position,
				player_group: selected_player_group,
			};

			axios
				.get(`${this.url}/baselineChart`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	emailBaselineChart = (date, sort_by, selected_position) => {
		return new Promise((resolve, reject) => {
			let params = {
				date: date,
				sort_by: sort_by,
				position: selected_position,
			};

			axios
				.get(`${this.url}/email/baseline`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getAllPlayers = (retired) => {
		return new Promise((resolve, reject) => {
			let params = {
				retired: retired,
			};

			axios
				.get(`${this.url}/players`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					// console.error(e);
					reject();
				});
		});
	};

	getPlayerMetrics = (start_date, end_date, acwr = false) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
				acwr: acwr,
			};

			axios
				.get(`${this.url}/playermetrics`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getPositions = (get_all = undefined) => {
		return new Promise((resolve, reject) => {
			let params = {
				get_all,
			};

			axios
				.get(`${this.url}/positions`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	compareSessions = (
		game_compare,
		num_games,
		date1,
		date2,
		date3,
		date4,
		date5,
		pos_filter,
		player_groups_filter
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				game_compare: game_compare,
				position: pos_filter,
				player_group: player_groups_filter,
			};
			if (game_compare) {
				params["num_games"] = num_games;
			} else {
				params["date1"] = date1;
				params["date2"] = date2;
				params["date3"] = date3;
				params["date4"] = date4;
				params["date5"] = date5;
			}

			axios
				.get(`${this.url}/compare`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	emailComparisonData = (
		game_compare,
		num_games,
		date1,
		date2,
		date3,
		date4,
		date5,
		pos_filter
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				game_compare: game_compare,
				position: pos_filter,
			};
			if (game_compare) {
				params["num_games"] = num_games;
			} else {
				params["date1"] = date1;
				params["date2"] = date2;
				params["date3"] = date3;
				params["date4"] = date4;
				params["date5"] = date5;
			}

			axios
				.get(`${this.url}/email/compare`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	onBoardRoster = (data) => {
		return new Promise((resolve, reject) => {
			let tempUrl = `${this.url}/onboard/roster`;
			let params = {
				data: data,
			};

			axios
				.post(tempUrl, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	getUnrecognizedNames = () => {
		return new Promise((resolve, reject) => {
			let params = {};

			axios
				.get(`${this.url}/unrecognizednames`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getAlternateNames = () => {
		return new Promise((resolve, reject) => {
			let params = {};

			axios
				.get(`${this.url}/nickname`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	addAlternateName = (nickname, player_id) => {
		return new Promise((resolve, reject) => {
			let params = {
				nickname,
				player_id,
				official_name: " ",
			};
			axios
				.post(`${this.url}/nickname`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	deleteAlternateName = (alternate_name_id) => {
		return new Promise((resolve, reject) => {
			let params = {
				alternate_name_id: alternate_name_id,
			};
			let config = { params };
			config.params = params;
			axios
				.delete(`${this.url}/nickname`, config)
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getTiles = (time_period = "today", date) => {
		return new Promise((resolve, reject) => {
			let params = {
				time_period,
			};
			if (date) {
				params.date = String(date);
			}

			axios
				.get(`${this.url}/tiles`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	saveDashboard = (layouts, dashItems) => {
		return new Promise((resolve, reject) => {
			let params = {
				layouts: layouts,
				dashItems: dashItems,
			};
			axios
				.post(`${this.url}/dashboard`, params, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getDashboard = (start_date, end_date) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
			};

			axios
				.get(`${this.url}/dashboard`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getDashboardTileData = (data, startDate, endDate) => {
		return new Promise((resolve, reject) => {
			let params = {
				data: JSON.stringify(data),
				startDate: startDate,
				endDate: endDate,
			};

			axios
				.get(`${this.url}/dashboardtile`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getWellnessTeams = () => {
		return new Promise((resolve, reject) => {
			let host = this.url;
			if (host.endsWith("/api")) {
				host = host.substring(0, host.lastIndexOf("/api"));
			}
			axios
				.get(`${host}/team-has-wellness`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};
	addPlayers = (players) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/v2/player`, players)
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	addCoach = (coach) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/create-user`, coach)
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	deleteCoach = (coachEmail) => {
		return new Promise((resolve, reject) => {
			axios
				.request({
					url: `${this.url}/create-user`,
					method: 'DELETE',
					data: { email: coachEmail }
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	getLeaderBoard = (
		start_date,
		end_date,
		position = undefined,
		player_groups = undefined,
		limit = 25,
		group_by = undefined
	) => {
		return new Promise((resolve, reject) => {
			let params = {
				start_date: start_date,
				end_date: end_date,
				position,
				player_groups,
				limit,
				group_by
			};

			axios
				.get(`${this.url}/leaderboard`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	getLeaderBoardPDF = (
		start_date,
		end_date,
		agg,
		position = undefined,
		player_groups = undefined,
		metrics = undefined,
		mode = undefined,
		limit = undefined,
		group_by = undefined,
		orientation = undefined
	) => {

		console.log(start_date, end_date, agg, position, player_groups, metrics, mode, limit, group_by, orientation);


		return new Promise((resolve, reject) => {
			const data = {
				start_date,
				end_date,
				agg,
				position,
				player_groups,
				metrics,
				mode,
				limit,
				group_by,
				orientation
			};

			console.log('Starting PDF request with data:', data);
			console.log('Request URL:', `${this.url}/leaderboardreport`);

			axios
				.post(
					`${this.url}/leaderboardreport`,
					{ ...data },
					{
						responseType: "blob",
						validateStatus: function (status) {
							console.log('Response status:', status);
							return status >= 200 && status < 300;
						},
					}
				)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					console.error('Request failed with error:', error);
					if (error.response) {

						if (error.response.data instanceof Blob) {
							const reader = new FileReader();
							reader.onload = () => {
								console.error('Blob content:', reader.result);
								reject(error.response.data);
							};
							reader.onerror = () => {
								console.error('Failed to read error response blob');
								reject(error.response.data);
							};
							reader.readAsText(error.response.data);
						} else {
							reject(error.response.data);
						}
					} else if (error.request) {
						console.error('No response received:', error.request);
						reject('No response received from server');
					} else {
						console.error('Error setting up request:', error.message);
						reject(error.message);
					}
				});
		});
	};

	getBWReportPDF = (start_date, end_date, weekly) => {
		return new Promise((resolve, reject) => {
			const data = {
				start_date,
				end_date,
				weekly
			};

			axios
				.post(
					`${this.url}/bw_report`,
					{ ...data },
					{
						responseType: "blob",
						validateStatus: function (status) {
							return status >= 200 && status < 300;
						},
					}
				)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	};

	getDataDeletionTypesForDate = (params) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/v2/data-deletion`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	deleteDataForDate = (payload) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/v2/data-deletion`, { ...payload })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e.response)
				});
		});
	};

	getComparisonTypes = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/singleStatTileComparisons`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};
	getMiscellaneousConstants = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/misc-constants`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	updateDifficultyBarConfig = (data) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/difficulty-bar-config`, data)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error("Error updating difficulty bar config: ", e);
					reject(e?.response?.data || "Error updating difficulty bar config");
				});
		});
	};

	getScatterplotData = (payload) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/scatterplot`, { ...payload })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	getMultiRangeComparisonData = (payload) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/comparison/multi-range`, { ...payload })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	get1v1ComparisonData = (payload) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/comparison/vs`, { ...payload })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	deletePracticePlanByDate = (date) => {
		const params = { date };
		return new Promise((resolve, reject) => {
			axios
				.delete(`${this.url}/practiceplan`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	}

	// Chatbot Endpoints
	callChatbotApi = ({ inboundMessage, messages, conversationId, version = "0.1", streamingUuid }) => {
		return new Promise((resolve, reject) => {
			let payload = {
				inbound_message: inboundMessage,
				messages: messages,
				conversation_id: conversationId
			};

			const urlPrefix = {
				"0.1": "/chatbot",
				"1.0": "/chatbot/v1/chat",
			}[version] || "/chatbot"
			const url = `${this.url}${urlPrefix}`

			const headers = streamingUuid ? {
				'gpsdv-uuid': streamingUuid
			} : {}

			axios
				.post(url, { ...payload }, {headers: headers})
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error("Error calling chatbot API: ", e);
					reject();
				});
		});
	}

	reviewAIMessage = (aiMessage, metadata, transcript, notes) => {
		return new Promise((resolve, reject) => {
			let payload = {
				input_sentence: aiMessage,
				metadata: metadata,
				transcript: transcript,
				user_notes: notes
			};
			axios
				.post(`${this.url}/chatbot/rag`, { ...payload })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error("Error calling chatbot API: ", e);
					reject();
				});
		});
	}

	getChatbotSuggestedQuestions = () => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/post-login-action`, {
					action: "suggested-dvai-questions"
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error("Error getting chatbot suggested questions: ", e);
					reject();
				});
		});
	}

	updateTeamSettings = (data) => {
		return new Promise((resolve, reject) => {
			let payload = {
				...data
			};
			axios
				.patch(`${this.url}/team/settings`, { ...payload })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error("Error calling update settings API: ", e);
					reject();
				});
		});
	}

	getDrillDownChartData = ({
		date,
		position,
		player_group,
		sessions,
		drilldown_type,
		metric_id,
		player_id
	}) => {
		return new Promise((resolve, reject) => {
			let params = {
				date,
				position,
				player_group,
				sessions,
				drilldown_type,
				metric_id,
				player_id
			};

			axios
				.get(`${this.url}/drilldown-charts`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	}

	getPresets = (params) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/presets`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject();
				});
		});
	};

	createPreset = (data) => {
		return new Promise((resolve, reject) => {
			let params = {
				...data
			};
			axios
				.post(`${this.url}/presets`, { ...params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	updatePreset = (data) => {
		return new Promise((resolve, reject) => {
			let payload = {
				...data
			};
			axios
				.patch(`${this.url}/presets`, { ...payload })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	}

	deletePreset = (preset_id) => {
		return new Promise((resolve, reject) => {
			let params = {
				preset_id,
			};
			axios
				.delete(`${this.url}/presets`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};
	
	getColorStrategies = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/color-strategies`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	createColorStrategy = (data) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/color-strategies`, data)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	updateColorStrategy = (data) => {
		return new Promise((resolve, reject) => {
			axios
				.patch(`${this.url}/color-strategies`, data)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	deleteColorStrategy = (id) => {
		return new Promise((resolve, reject) => {
			axios
				.delete(`${this.url}/color-strategies`, {
					params: { strategy_id: id }
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	getWeatherPresets = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/weather-presets`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	addWeatherPreset = (zipcode, name) => {
		return new Promise((resolve, reject) => {
			const data = {
				zipcode,
				name
			};
			axios
				.post(`${this.url}/weather-presets`, data)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	deleteWeatherPreset = (zipcode) => {
		return new Promise((resolve, reject) => {
			const params = {
				zipcode
			};
			axios
				.delete(`${this.url}/weather-presets`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	updateUserPermissions = (userId, permissions) => {
		return new Promise((resolve, reject) => {
			axios
				.patch(`${this.url}/create-user`, {
					user_id: userId,
					permissions
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	getWeatherData = (zipcode, startDate, endDate) => {
		return new Promise((resolve, reject) => {
			let params = {
				zipcode,
				start_date: startDate,
			};
			
			if (endDate) {
				params.end_date = endDate;
			}

			axios
				.get(`${this.url}/weather`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};
	
	generateGeneralReport = (reportConfig) => {
		/**
		 * Unified method for generating all types of reports through the new general report endpoint.
		 * This consolidates the various disparate report methods into a single interface.
		 * 
		 * @param {Object} reportConfig - Configuration object for the report
		 * @param {string} reportConfig.report_type - Type of report to generate
		 * @param {string} [reportConfig.date] - Date for single date reports (YYYY-MM-DD)
		 * @param {Array<string>} [reportConfig.date_range] - Date range for range reports [start, end]
		 * @param {Array<string>} reportConfig.emails - Email recipients
		 * @param {Array<string>} [reportConfig.position_filter] - Position filters
		 * @param {Array<number>} [reportConfig.player_group_filter] - Player group IDs
		 * @param {number} [reportConfig.player_filter] - Single player ID for player reports
		 * @param {boolean} [reportConfig.group_by_position] - Whether to group by position
		 * @param {string} [reportConfig.comparison_type] - Comparison type for testing/forceplate
		 * @param {Array} [reportConfig.metrics] - Report-specific metrics
		 * @param {Array<string>} [reportConfig.player_report_data_streams] - Data streams for player reports
		 * 
		 * Supported report types:
		 * - 'gps': GPS Report
		 * - 'coach-gps': Coach's Report (GPS)
		 * - 'forceplate': Force Plate Report
		 * - 'testing': Testing Report  
		 * - 'player_report': Individual Player Report
		 * - 'report-card-bulk': Team Report Cards - Bulk Export
		 * - 'daily_all_tech': Daily Report (All Tech)
		 * - 'single_week_distance_breakdown': Single Week Distance Breakdown
		 * - 'multi_week_distance_breakdown': Multi Week Distance Breakdown
		 * - 'body_weight_report': One Pager Body Weight Report
		 * - 'custom_breakdown_table': Custom Breakdown Table (Coming Soon)
		 */
		return new Promise((resolve, reject) => {
			if (!reportConfig.report_type) {
				reject("report_type is required");
				return;
			}

			if (!reportConfig.emails || reportConfig.emails.length === 0) {
				reject("At least one email recipient is required");
				return;
			}

			const start = Date.now();
			const payload = {
				...reportConfig
			};

			axios
				.post(`${this.url}/generate-report`, payload, {
					timeout: 180000, // 3 minute timeout like other report methods
				})
				.then((x) => resolve(x.data))
				.catch((e) => {
					const end = Date.now();
					console.log("Time elapsed", end - start);

					// Handle timeout scenario like other report methods
					if (end - start > 59000 && e?.message === "Network Error" && e?.response === undefined) {
						const custom_err = "The report will be sent shortly."
						reject(custom_err);
					}
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	};

	addTreatmentLog = (data) => {
		return new Promise((resolve, reject) => {
			axios
				.post(`${this.url}/treatment-log`, data)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	}

	getAllTreatmentLogs = (params) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/treatment-log`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	}

	getTreatmentLog = (id) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/treatment-log/${id}`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	}

	deleteTreatmentLog = (id) => {
		return new Promise((resolve, reject) => {
			axios
				.delete(`${this.url}/treatment-log/${id}`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	}

	updateTreatmentLog = (id, data) => {
		return new Promise((resolve, reject) => {
			axios
				.patch(`${this.url}/treatment-log/${id}`, data)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	}

	getActivityLog = (page, activity, userId, startDate, endDate) => {
		if (startDate) {
			startDate = new Date(startDate)
		}

		if (endDate) {
			endDate = new Date(endDate)
		}

		const params = {
			page,
			start_date: startDate ? new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1).toISOString() : startDate,
			end_date: endDate ? new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1).toISOString() : endDate,
			user_ids: userId,
			activity: activity
		};

		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/activity-log`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				})
		})
	}

	getPermissionsForTeamUsers = () => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/platform-permissions`)
				.then((x) => resolve(x.data))
				.catch((e) => {
					console.error(e);
					reject(e?.response?.data || DEFAULT_ERR_MESSAGE);
				});
		});
	}

	getStatusTrackerData = (date) => {
		return new Promise((resolve, reject) => {
			let params = {
				date,
			};
			axios
				.get(`${this.url}/status-tracker`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject();
				});
		});
	};

	createCustomStatus = (data) => {
		return new Promise((resolve, reject) => {
			let params = {
				...data
			};
			axios
				.post(`${this.url}/status-tracker/status`, { ...params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	updateCustomStatus = (data) => {
		return new Promise((resolve, reject) => {
			let params = {
				...data
			};
			axios
				.patch(`${this.url}/status-tracker/status`, { ...params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	deleteCustomStatus = (data) => {
		return new Promise((resolve, reject) => {
			let params = {
				...data
			};
			axios
				.delete(`${this.url}/status-tracker/status`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	getAvailableStatuses = (start_date, end_date) => {
		const params = {
			start_date,
			end_date
		}
		return new Promise((resolve, reject) => {
			axios
				.get(`${this.url}/status-tracker/status`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	selectPlayerStatus = (data) => {
		return new Promise((resolve, reject) => {
			let params = {
				...data
			};
			axios
				.post(`${this.url}/status-tracker/select-status`, {...params})
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};

	deletePlayerStatus = (data) => {
		return new Promise((resolve, reject) => {
			let params = {
				...data
			};
			axios
				.delete(`${this.url}/status-tracker/select-status`, { params })
				.then((x) => resolve(x.data))
				.catch((e) => {
					reject(e);
				});
		});
	};
}

export const trainingAPI = new TrainingAPI();
